import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';

import { collapseUnusedFloatingFooterSpacerSx } from './ConfirmParticipantOperationModal.style';

export const BUYER_EMAIL_CHANGE_NOTICE_HEADER = 'Buyer Email Change Notice';
export const BUYER_EMAIL_CHANGE_NOTICE_MESSAGE =
    "Changing the buyer's email address will reset the current ecommerce order when the deal is saved. The buyer will get a new checkout link and must complete the process again.";

type BuyerEmailChangeNoticeProps = {
    show: boolean;
    onConfirm: () => void;
    onClose: () => void;
};

export const BuyerEmailChangeNotice: FC<BuyerEmailChangeNoticeProps> = ({ show, onConfirm, onClose }) => (
    <Modal
        data-testid="buyer-email-change-notice-modal"
        footer={{
            layout: 'rightAligned',
            options: {
                action: onClose,
                label: 'Cancel',
                buttonStyle: 'secondary',
                customIdentifiers: { optionButton0: { dataTestId: 'buyer-email-change-notice-cancel-btn' } }
            },
            primary: {
                action: onConfirm,
                label: 'Continue',
                customIdentifiers: { primaryButton: { dataTestId: 'buyer-email-change-notice-confirm-btn' } }
            }
        }}
        header={BUYER_EMAIL_CHANGE_NOTICE_HEADER}
        id="buyer-email-change-notice-modal"
        onHide={onClose}
        size="small"
        sx={collapseUnusedFloatingFooterSpacerSx}
        show={show}
    >
        <p>{BUYER_EMAIL_CHANGE_NOTICE_MESSAGE}</p>
    </Modal>
);
